import React from 'react';
import { getLikerDisplayName } from '../../utils/displayName';

export default function WhoLikedModal({ showKey, whoLiked, onClose }) {
  if (!showKey || !whoLiked?.[showKey]?.length) return null;

  const list = whoLiked[showKey];
  const visibleCount = 20;
  const hasMore = list.length > visibleCount;
  const visible = hasMore ? list.slice(0, visibleCount) : list;
  const remaining = list.length - visible.length;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1200,
        backgroundColor: 'transparent',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        paddingBottom: 80,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'rgba(74, 76, 83, 0.98)',
          color: '#f9fafb',
          borderRadius: '10px',
          padding: '10px 14px',
          maxWidth: '320px',
          maxHeight: '260px',
          overflowY: 'auto',
          boxShadow: '0 18px 35px rgba(155, 162, 180, 0.55)',
          fontSize: '12px',
          position: 'relative',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 4,
            right: 6,
            background: 'transparent',
            border: 'none',
            color: '#e5e7eb',
            cursor: 'pointer',
            fontSize: 14,
          }}
          aria-label="Close"
        >
          ×
        </button>
        <div style={{ fontWeight: 600, marginBottom: '6px', opacity: 0.9, paddingRight: '14px' }}>
          Liked by
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          {visible.map((liker, idx) => (
            <div key={idx} style={{ padding: '2px 0' }}>
              <span style={{ fontWeight: 500 }}>{getLikerDisplayName(liker)}</span>
            </div>
          ))}
          {hasMore && (
            <div style={{ paddingTop: '4px', fontWeight: 500 }}>and {remaining} more...</div>
          )}
        </div>
      </div>
    </div>
  );
}
